<template>
  <Modal
    open
    @close="handleCancelButtonClick"
    size="small"
    :hideScrollbar="true"
    :roundedOnMobile="true"
    class="[&_.modal-position]:!px-6"
  >
    <div class="flex flex-col gap-8">
      <SectionHeader :title="__('Notes')">
        <template #icon>
          <Icon class="text-3xl text-primary" name="chat" />
        </template>
      </SectionHeader>

      <div
        class="flex max-h-[25rem] flex-grow flex-col gap-2 rounded-2xl bg-white p-6 shadow-element md:p-8"
      >
        <ul
          v-if="data.length"
          ref="noteList"
          class="flex-grow space-y-2 overflow-y-auto"
        >
          <li v-for="note in data" :key="note.id" class="flex gap-2.5">
            <div class="flex shrink-0 flex-col items-center gap-2">
              <img
                :src="note.recruiter.profile_picture_url"
                :alt="__('Recruiter avatar')"
                class="h-8 w-8 shrink-0 rounded-full ring-1 ring-zinc-100"
              />

              <span class="block h-full w-[1.5px] bg-zinc-300" />
            </div>
            <div class="pb-12">
              <span class="block text-xs font-medium text-zinc-600">
                {{ note.recruiter.name }}
              </span>

              <span class="block text-xs text-zinc-600">
                {{ `${__('commented')} ${note.created_at}` }}
              </span>

              <p class="mt-1 text-sm leading-tight text-zinc-600">
                {{ note.text }}
              </p>
            </div>
          </li>
        </ul>

        <!-- <span v-else class="mb-6 text-zinc-600">
            {{ __('No notes found') }}
          </span> -->

        <div class="flex gap-2.5">
          <img
            :src="recruiterAvatarUrl"
            :alt="__('Recruiter avatar')"
            class="h-8 w-8 shrink-0 rounded-full ring-1 ring-zinc-100"
          />

          <form
            class="relative flex-grow overflow-hidden rounded-md pb-14 ring-1 ring-zinc-200 focus-within:ring-2 focus-within:ring-secondary"
            @submit.prevent="handleAddNote"
          >
            <textarea
              v-model="note_text"
              class="w-full resize-none border-0 px-3 py-2 text-sm font-normal text-zinc-600 placeholder:text-zinc-400 focus:ring-0"
              :placeholder="`${__('Add your note')}...`"
            />
            <Button
              type="submit"
              variant="outline"
              class="absolute bottom-4 right-5 flex items-center gap-1.5 !text-zinc-600 !ring-zinc-200 hover:!bg-zinc-600/5"
            >
              <!-- <Icon class="animate-spin text-lg" name="progress_activity" /> -->

              <span>{{ __('Send note') }}</span>
            </Button>
          </form>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import Modal from '@/components/block/modal/modal.vue';
  import SectionHeader from '@/components/global/SectionHeader.vue';
  import { nextTick, onMounted, ref } from 'vue';
  import { __ } from '@/helpers';

  const props = defineProps({
    candidateId: {
      type: Number,
      required: false
    },
    data: {
      type: Object,
      required: true
    },
    recruiterAvatarUrl: {
      type: String,
      required: true
    }
  });

  const note_text = ref('');
  const noteList = ref(null);
  const emits = defineEmits(['cancel', 'addNote']);

  function handleCancelButtonClick() {
    emits('cancel');
  }
  async function handleAddNote() {
    if (note_text.value.trim() === '') {
      return;
    }

    emits('addNote', {
      candidate_id: props.candidateId,
      note_text: note_text.value
    });

    note_text.value = '';

    if (noteList.value) {
      await nextTick();
      setTimeout(() => {
        if (noteList.value) {
          noteList.value.scrollTo({
            top: noteList.value.scrollHeight,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }
  onMounted(async () => {
    await nextTick();
    if (!noteList.value) {
      return;
    }
    noteList.value.scrollTo({
      top: noteList.value.scrollHeight,
      behavior: 'smooth'
    });
  });
</script>
